import React, { FC } from 'react';
import { ProductsListPageSkeleton } from '../placementProduct/placementProductSkeleton';

export const DamPageSkeleton: FC = () => <ProductsListPageSkeleton titleWidth='180px' actionWidth='110px' />;
